import React from "react";
import EntriesTable from "./EntriesTable";
import WagerTypes from "../constants/WagerTypes";

const WinPlaceShow = ({
  raceInfo,
  entriesInfo,
  idWin,
  idPlace,
  idShow,
  addToCart,
  setTicketIndex,
  ticketIndex,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Win"
        role="tabpanel"
        aria-labelledby="Win"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.WPS.name}
          idWT={{ Win: idWin, Place: idPlace, Show: idShow }}
          addToCart={addToCart}
          setTicketIndex={setTicketIndex}
          ticketIndex={ticketIndex}
        />
      </div>
    </>
  );
};

export default WinPlaceShow;
